import { useEffect } from "react";
import Typography from "../shared/typography";
import { useGroupChatContext } from "../../hooks/GroupChatContextWrapper";

export default function GroupMembersList({ groupId }: { groupId: string }) {
  const { selectGroupChat, groupChatMembers } = useGroupChatContext();

  useEffect(() => {
    selectGroupChat(groupId);
  }, [groupId, selectGroupChat]);

  if (!groupChatMembers.length) return null;

  return (
    <div className="mb-4 p-4 bg-white rounded-lg shadow-sm">
      <Typography variant="subtitle1" className="mb-2 text-terracotta">
        Members ({groupChatMembers.length})
      </Typography>
      <ul className="space-y-1">
        {groupChatMembers.map((m) => (
          <li key={m.user_id} className="text-sm text-brown-700">
            {m.user.first_name} {m.user.last_name}
          </li>
        ))}
      </ul>
    </div>
  );
}
